import React, { useEffect } from 'react';
import '../../styles/pseudocode.css';
import Error from '../../assets/error.svg';
import CodeAlert from '../../assets/code_alert.svg';
import CodeBell from '../../assets/code_bell.svg';
import CodeError from '../../assets/code_error.svg';
import CodeLogo from '../../assets/code_logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const Section1 = () => {

return (
    <div className="gradient-black">
        <h2 className="text-center mb-4 px-5 scroll-fade-in">The typical player's path</h2>
        <div className="d-flex justify-content-center scroll-fade-in">
            <div className='col-10 col-md-8 col-lg-4'>
                <div id="code-column" style={{border: "1px solid #3C3E4C"}}> 
                    <div><p className='m-0 px-3 pt-3 pb-2 bg-black'><span id="line-number">1</span> Practice tech skill</p></div>
                    <div><p className='m-0 px-3 py-2 bg-black' style={{ color: "#888888" }}><span id="line-number">2</span> //Build foundation</p></div>
                    <div><p className='m-0 px-3 py-2 bg-black'><span id="line-number">3</span> Learn matchups</p></div>
                    <div><p className='m-0 px-3 py-2 bg-black' style={{ color: "#888888" }}><span id="line-number">4</span> //Learn to adapt</p></div>
                    <div><p className='m-0 px-3 pt-2 pb-3 bg-black' style={{ color: "#888888" }}><span id="line-number">5</span> //Develop the mental game</p></div>
                    <div className='d-flex align-items-center' id="missing-dependency" style={{paddingLeft: "20px"}}>
                            <img src={Error} alt="Error" className="d-flex" style={{width: "25px", height: "25px"}} />
                            <p className="m-0 p-3">Missing dependency [line 4]</p>
                    </div>
                    <div className='d-flex align-items-center' id="warning-dependency" style={{paddingLeft: "20px"}}>
                            {/* <img src={CodeAlert} alt="Warning" className="d-flex" style={{width: "25px", height: "25px"}} /> */}
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                            <p className="m-0 p-3">Warnings [line 2, line 5]</p>
                    </div>
                </div>
            </div>
        </div>
        <div className='d-flex justify-content-center scroll-fade-in'>
            <div className='col-10 col-md-8 col-lg-4 mt-4 mb-5 p-4' style={{backgroundColor: "#171A29", border: "1px solid #3C3E4C"}}>
                    <p className=''>Seriously. Too many players skip over critical information and jump straight into tech skill and matchups.</p>
                    <p className='m-0'>That's why Melee Academy was built to help you develop every part of the game, one step at a time.</p>
            </div>
        </div>
        <div className='d-none d-sm-flex justify-content-around mt-5 py-1 scroll-fade-in' id="code-bar" style={{color: "#3C3E4C", borderTop: "1px solid #3C3E4C", borderBottom: "1px solid #3C3E4C"}}>
            <div className='d-flex ps-3' style={{borderLeft: "1px solid #3C3E4C"}}>
                    <img src={CodeLogo} alt="Code Logo" style={{}} />
                    <img src={CodeError} alt="Code Error" style={{}} />
                    <p className='mb-0 px-2'>1</p>
                    <img src={CodeAlert} alt="Code Alert" style={{}} />
                    <p className='mb-0 px-2'>2</p>
            </div>
            <div className='d-flex pe-3' style={{borderRight: "1px solid #3C3E4C", width: "360px"}}>
                    <p className='mb-0 px-2'>Ln 18, Col 50</p>
                    <p className='mb-0 px-2'>Spaces: 4</p>
                    <p className='mb-0 px-2'>UTF-8</p>
                    <p className='mb-0 px-2'>HTML</p>
                    <p className='mb-0 px-2'>Layout: US</p>
                    <img src={CodeBell} alt="Code Bell" style={{}} />
            </div>
        </div>
    </div>
);
};

export default Section1;